import ProductCard from "@/components/product-card";
import { COLLECTION_ITEMS } from "@/lib/constants";

export default function Collection() {
  return (
    <div className="min-h-screen">
      {/* Hero Banner */}
      <section 
        className="relative h-64 flex items-center justify-center bg-cover bg-center"
        style={{ 
          backgroundImage: `url(https://static.wixstatic.com/media/f85fef_a0b2b687295940e5a507437830cd3069~mv2_d_3888_2592_s_4_2.jpg/v1/fill/w_1919,h_238,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f85fef_a0b2b687295940e5a507437830cd3069~mv2_d_3888_2592_s_4_2.jpg)`
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40" />
        <div className="relative z-10 text-center text-white">
          <h1 className="text-5xl font-serif font-bold mb-4">Collection</h1>
          <p className="text-xl">Handcrafted Heritage Clothing</p>
        </div>
      </section>

      {/* Collection Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-serif font-bold text-[var(--perahan-charcoal)] mb-4">
              Our Complete Collection
            </h2>
            <p className="text-lg text-[var(--perahan-gray)] max-w-3xl mx-auto">
              Each piece in our collection represents generations of craftsmanship, 
              combining traditional block printing techniques with contemporary design sensibilities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {COLLECTION_ITEMS.map((product) => (
              <ProductCard
                key={product.id}
                title={product.title}
                description={product.description}
                image={product.image}
              />
            ))}
          </div>

          {/* Additional Collection Info */}
          <div className="mt-16 bg-white p-8 rounded-lg shadow-lg">
            <div className="text-center">
              <h3 className="text-2xl font-serif font-bold text-[var(--perahan-charcoal)] mb-4">
                Custom Orders Available
              </h3>
              <p className="text-[var(--perahan-gray)] mb-6 max-w-2xl mx-auto">
                Don't see exactly what you're looking for? We offer custom designs and personalized 
                block printing services. Contact us to discuss your vision and create something unique.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={() => {
                    const message = encodeURIComponent("Hi! I'm interested in a custom order. Could you please provide more information about your custom design services?");
                    window.open(`https://wa.me/923035074455?text=${message}`, '_blank');
                  }}
                  className="btn-terracotta"
                >
                  Inquire About Custom Orders
                </button>
                <button 
                  onClick={() => {
                    const message = encodeURIComponent("Hello! I'd like to visit your store. Could you please confirm your hours and location?");
                    window.open(`https://wa.me/923035074455?text=${message}`, '_blank');
                  }}
                  className="btn-primary"
                >
                  Visit Our Store
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
